import { configureStore } from "@reduxjs/toolkit";

import masterDataReducer from "@/lib/redux/features/master-data/masterDataSlice";
import userSelectedDetailsReducer from "@/lib/redux/features/user-selected-details/userSelectedDetailsSlice";
import vehiclesReducer from "@/lib/redux/features/vehicles/vehiclesSlice";

export const makeStore = () => {
  return configureStore({
    reducer: {
      masterData: masterDataReducer,
      userSelectedDetails: userSelectedDetailsReducer,
      vehicles: vehiclesReducer,
    },
    devTools: process.env.NODE_ENV !== "production",
  });
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
